<div class="button-group-holder" [ngClass]="{'single': !multi}">
  <mat-button-toggle-group vertical="true" [formControl]="formControl" [value]="selected">
    <mat-button-toggle *ngFor="let item of visibleOptions" (change)="handleData($event.value)" value="{{item.value ||
    item.slug}}"><span class="paragraph2">{{item.name}}</span></mat-button-toggle>
  </mat-button-toggle-group>
</div>
